"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FilterOperator = {
  AND: 'and',
  OR: 'or'
};
var _default = exports.default = FilterOperator;



//////////////////
// WEBPACK FOOTER
// ./~/primevue/api/FilterOperator.js
// module id = 766
// module chunks = 7